























import { formatImageUrl } from "@/common/utils";
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "GroupNotFound",
})
export default class GroupNotFound extends Vue {
  getImagePath() {
    return formatImageUrl("not-found.jpg", "1600x");
  }
}
